<!--
  navItem „Vertrag“ — Vertrag und Provisionszeile im Überblick.
  Im Provisionszeilen-Block tragen die nullbaren Rechenfelder pro Feld die Tatsachenaussage
  „nicht berechnet“; die Erklärung steht einmal am Kopf dieses Blocks.
-->
<div class="cp-provision-contract-agent-contract">

    @if (!initialized || busy) {
        <p-skeleton height="16rem"></p-skeleton>
    } @else if (!provisionContractAgentId) {
        <p-message severity="info" text="Kein Provisionssatz ausgewählt." styleClass="w-full"></p-message>
    } @else if (loadFailed) {
        <p-message severity="error" text="Der Provisionssatz konnte nicht geladen werden."
                   styleClass="w-full"></p-message>
    } @else {

        <cp-provision-object-data
                objectType="cm.Contract"
                [objectId]="contractId"
                widgetAlias="cp.contractAgent.contract"
                widgetTitle="Vertrag"
                [fields]="contractFields"
                [columns]="columns"
                emptyText="Zu diesem Provisionssatz ist kein Vertrag hinterlegt.">
        </cp-provision-object-data>

        <div class="mt-4">
            <cp-provision-object-data
                    objectType="cp.ProvisionContract"
                    [objectId]="provisionContractId"
                    widgetAlias="cp.contractAgent.provisionContract"
                    widgetTitle="Provisionszeile"
                    [fields]="provisionContractFields"
                    [pendingFields]="provisionContractPendingFields"
                    [pendingFalseFields]="provisionContractPendingFalseFields"
                    [columns]="columns"
                    emptyText="Zu diesem Provisionssatz ist keine Provisionszeile hinterlegt.">
            </cp-provision-object-data>
        </div>

    }

</div>
